import {Injectable} from '@angular/core';
import {UserToken} from '../api/user/user.model';
import {parseSavedData, scrumbleDataToSave} from '../helpers/scrumble-data';
import {AppSettings} from '../helpers/app-settings';
import {first} from 'rxjs/operators';
import {UserValidationsService} from '../api/user/user-validations.service';
import {UserValidation} from '../api/user/user-validation.model';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {interval, Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserValidationLocalService {

  private tokens: UserToken[] = [];
  private appSettings: AppSettings = new AppSettings();
  private validationSettings: UserValidation;

  private timerRefreshTokens: Subscription;

  constructor(private valService: UserValidationsService, private router: Router,
              private toastr: ToastrService) {

    this.tokens = parseSavedData<UserToken[]>(this.appSettings.get('app-uv-tk'), []);
    this.validationSettings = parseSavedData<UserValidation>(this.appSettings.get('app-uv-settings'), new UserValidation());
  }

  public init(): void {
    this.refreshData();
    this.refreshTokens();
  }


  private refreshData(): void {
    // Verificar si es que hay user-validation
    this.valService.getSetting()
      .pipe(first())
      .subscribe(validationSettings => {
        this.validationSettings = validationSettings;
        this.appSettings.set('app-uv-settings', scrumbleDataToSave(this.validationSettings));

      });
  }

  private refreshTokens(): void {

    const tokens = this.getValidTokens();

    // Solo si hay tokens para validar
    if (tokens.length > 0) {

      // Enviar cada uno de los tokens activos para validacion
      this.valService.validateTokens(tokens.map(token => token.token))
        .pipe(first())
        .subscribe(tokenValidation => {

          this.tokens = tokenValidation;
          this.saveTokens();

        },
          () => {

          });
    }

    // Cada media hora se corre el refresh de los tokens si es que esta activada la validacion
    if (this.timerRefreshTokens === undefined && this.isActive()) {
      this.timerRefreshTokens = interval(1800000)
        .subscribe(() => {
          this.refreshTokens();
        });
    }
  }

  public getValidTokens(): UserToken[] {
    this.tokens = this.tokens.filter(data => new Date(Date.parse(data.valid_until)) > new Date());
    this.saveTokens();
    return this.tokens;
  }

  public addToken(token: UserToken): void {
    this.tokens.push(token);
    this.saveTokens();
  }

  private saveTokens(): void {
    this.appSettings.set('app-uv-tk', scrumbleDataToSave(this.tokens));
  }

  public isActive(): boolean {
    return this.validationSettings.active;
  }

  public navigateToValidation(urlToGoBack: string): void {

    // post validation go back url
    this.appSettings.set('app-uv-gburl', urlToGoBack);

    const service = this.getService();

    if (service) {
      this.router.navigate(['/app/user-validation/' + this.getService()]);
    } else {
      this.toastr.error('Ocurrió un error al intentar realizar la validación del usuario. Contacte con el administrador del sistema.');
    }

  }

  public navigateBack(): void {

    const urlToGoBack = this.appSettings.get('app-uv-gburl', '/app/');

    this.appSettings.unset('app-uv-gburl');

    this.router.navigate([urlToGoBack], {
      replaceUrl: true
    });
  }


  private getService(): string {

    // Se verifica servicio de validacion
    let service: string =
      this.isServiceActive(this.validationSettings.service) ? this.validationSettings.service : undefined;

    if (!service) {
      service =
        this.isServiceActive(this.validationSettings.fallback_service) ? this.validationSettings.fallback_service : undefined;
    }

    return service;
  }

  public isServiceActive(serv): boolean {
    return this.validationSettings?.services[serv + '_serv']?.active || false;
  }
}
